import { Box, Flex } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';

import { getFormValues, setImportIndicatorType } from 'redux/DataImportSlice';

import { FieldLabel, StepHeading, StepRadio } from '../actionStepUi';

import SingleIndicators from './Indicators/SingleIndicators';
import MultipleIndicators from './Indicators/MultipleIndicators';
import SingleIndWoCol from './Indicators/SingleIndWoCol';

const DataStepsThree = () => {
  const dispatch: any = useDispatch();
  const getFormValue = useSelector(getFormValues);

  return (
    <Box w='100%'>
      <StepHeading
        title='Select indicators'
        subtitle='Tell us which indicators this file contains.'
      />
      <FieldLabel>Are you importing multiple indicators?</FieldLabel>
      <Flex gap={6} pb={2}>
        <StepRadio
          isSelected={getFormValue.importIndicatorType === '1'}
          onSelect={() => dispatch(setImportIndicatorType('1'))}
        >
          Single
        </StepRadio>
        <StepRadio
          isSelected={getFormValue.importIndicatorType === '2'}
          onSelect={() => dispatch(setImportIndicatorType('2'))}
        >
          Multiple
        </StepRadio>
      </Flex>
      {getFormValue?.importIndicatorType === '1' && getFormValue?.dataPeriod === '1' && (
        <SingleIndicators getFormValue={getFormValue} />
      )}
      {getFormValue?.importIndicatorType === '1' && getFormValue?.selectedTimePeriod === 'row' && (
        <SingleIndicators getFormValue={getFormValue} />
      )}

      {getFormValue?.importIndicatorType === '1' &&
        getFormValue?.selectedTimePeriod === 'column' && (
          <SingleIndWoCol getFormValue={getFormValue} />
        )}
      {getFormValue?.importIndicatorType === '2' && (
        <MultipleIndicators getFormValue={getFormValue} />
      )}
    </Box>
  );
};

export default DataStepsThree;
